<template>
    <div class="page-banner-setting">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">積分管理</div>
            <div class="breadcrumb-item">門店積分設置</div>
        </div>
        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="img">
                    <div class="table-img-wrap">
                        <img :src="row.url" alt="">
                    </div>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <!-- <div class="pg-btn style1" @click="handleDelete(index)">刪除</div> -->
                    </div>
                </template>
            </Table>
            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>
                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>
                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data()
        {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
                form: {
                    keywords: ''
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '積分',
                            key: 'credit',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '價格',
                            key: 'price',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '贈送',
                            key: 'extra_credit',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '贈送積分有效天數',
                            key: 'extra_credit_day',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '門店/線上',
                            key: 'is_online',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '排序',
                            key: 'sort_credit',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '描述',
                            key: 'describe',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '更新時間',
                            key: 'created_at',
                            align: 'center',
                            sortable: true,
                            minWidth: 160
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            width: 100
                        }
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            getList()
            {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.creditAdminList,
                    method: 'get',
                    data: {
                        is_online: 2,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++)
                        {
                            if(resData[i].is_online == 1){
                                resData[i].is_online = '線上';
                            }
                            else if(resData[i].is_online == 2){
                                resData[i].is_online = '門店';
                            }

                            if(resData[i].amount_type.type == null){
                                resData[i].amount_type.type = '- - -';
                            }
                            else{
                                if(resData[i].amount_type.type == 1){
                                    resData[i].amount_type.type = '積分';
                                }
                                if(resData[i].amount_type.type == 2){
                                    resData[i].amount_type.type = '集金幣';
                                }
                            }

                            tempArr.push({
                                id: resData[i].id,
                                credit: resData[i].credit + ' 積分',
                                price: '$' + resData[i].price,
                                extra_credit: resData[i].extra_credit + ' ' +resData[i].amount_type.type,
                                extra_credit_day: resData[i].extra_credit_day + '天',
                                created_at: resData[i].created_at,
                                sort_credit: resData[i].sort,
                                type: resData[i].type,
                                describe: resData[i].describe == null ? '- - -' : resData[i].describe,
                                is_online: resData[i].is_online,
                                amount_type: resData[i].amount_type.type, //設定線上線下贈送部分 -> 1.集金幣, 2.積分
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch((err) =>
                {
                   this.isSubmiting = false;
                });
            },
            handleToAdd()
            {
                this.$router.push({path: '/creditEditOffline'});
            },

            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/creditEditOffline?id=' + tableData[index].id});
            },
            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.creditDelete + '/' + tableData[index].id,
                            method: 'delete'
                        }).then((res) =>
                        {
                            this.isSubmiting = false;
                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);
                                this.pageIndex = 1;
                                this.getList();
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });

                    }
                });
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'CreditOffline';
</style>